// extracted by mini-css-extract-plugin
module.exports = {"HeaderMobileMenu":"HeaderMobileMenu_HeaderMobileMenu__2SlH8","HeaderMobileMenu__logo":"HeaderMobileMenu_HeaderMobileMenu__logo__X_PHI"};